<template>
  <span class="aspect" :class="[`aspect--${tone}`, `aspect--k-${aspect}-${value}`]">
    <!-- eslint-disable-next-line vue/no-v-html -- constant art from loreArt.js -->
    <svg class="aspect__icon" viewBox="0 0 16 16" aria-hidden="true" v-html="art" />
    <span v-if="word" class="aspect__word">{{ label }}</span>
  </span>
</template>

<script>
import { ASPECT_WORDS } from '@/engine/lore';
import { artForAspect } from './loreArt';

// One property of a nature: hot or cold, wet or dry, heavy or light, as a
// badge. `tone` says how sure it is - ink (the world told you), pencil (it
// follows from what you know), or plain.
export default {
  name: 'Aspect',
  props: {
    aspect: { type: String, required: true },
    value: { type: Boolean, required: true },
    word: { type: Boolean, default: true },
    tone: { type: String, default: 'plain' },
  },
  computed: {
    art() { return artForAspect(this.aspect, this.value); },
    label() { return ASPECT_WORDS[this.aspect][String(this.value)]; },
  },
};
</script>
